'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useModal } from './modal-context';
import { useSharedUI } from './ui-adapter';
export function ModalRenderer() {
  const $ = _c(9);
  const {
    modals,
    hideModal
  } = useModal();
  const {
    ModalShell
  } = useSharedUI();
  let t0;
  if ($[0] !== ModalShell || $[1] !== hideModal || $[2] !== modals) {
    let t1;
    if ($[4] !== ModalShell || $[5] !== hideModal) {
      t1 = modal => <ModalShell key={modal.id} open={true} onOpenChange={open => {
        if (!open) {
          hideModal(modal.id);
        }
      }} title={modal.title} description={modal.description} className={modal.className} showCloseButton={modal.showCloseButton ?? true} fullscreenOnMobile={modal.fullscreenOnMobile ?? false} preventAutoFocus={modal.preventAutoFocus ?? false}>{modal.component}</ModalShell>;
      $[4] = ModalShell;
      $[5] = hideModal;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    t0 = modals.map(t1);
    $[0] = ModalShell;
    $[1] = hideModal;
    $[2] = modals;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[7] !== t0) {
    t1 = <>{t0}</>;
    $[7] = t0;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}